/**
 * Create a centered popup window for OAuth flows
 */
export function createCenteredPopupWindow(
    url: string,
    title: string,
    width: number = 800,
    height: number = 600
): Window | null {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    const features = `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes`;

    return window.open(url, title, features);
}

/**
 * Monitor popup window and execute callback when closed
 */
export function monitorPopupWindow(popupWindow: Window | null, onClose: () => void, interval: number = 300): void {
    if (!popupWindow) {
        return;
    }

    const timer = setInterval(() => {
        if (popupWindow.closed) {
            clearInterval(timer);
            onClose();
        }
    }, interval);
}

/**
 * Open OAuth popup and execute callback when it closes
 */
export function openOAuthPopup(
    url: string,
    title: string,
    onClose: () => void,
    width: number = 800,
    height: number = 600
): Window | null {
    const popupWindow = createCenteredPopupWindow(url, title, width, height);

    if (popupWindow) {
        monitorPopupWindow(popupWindow, onClose);
    } else {
        alert('Please allow popups for this website');
    }

    return popupWindow;
}
